;(($) => {
    $(document).ready(() => {
        // set vars
        window.CryptoPayLang = CryptoPayConfig.lang;
        window.CryptoPayConfig = window.cpTyping(CryptoPayConfig);
        window.CryptoPayApp = InitCryptoPay('cryptopay', CryptoPayConfig);

        // auto start, if order exists and autoStart is true
        if (Boolean(window.CryptoPayVars?.order && window.CryptoPayVars?.autoStart)) {
            const params = window.CryptoPayVars?.params || {};
            window.CryptoPayApp.start(window.CryptoPayVars.order, params);
        }

        if (!window.customElements.get('cp-powered-by')) {
            const template = document.createElement('template');
            template.innerHTML = `
                <div class="footer">
                    <span class="powered-by">
                        Powered by
                    </span>
                    <a href="https://beycanpress.com/cryptopay?utm_source=powered_by&utm_medium=web_component" target="_blank">CryptoPay</a>
                </div>
                <style>
                    .footer {
                        display: flex;
                        font-size: 14px;
                        padding: 20px 30px;
                        padding-bottom: 0px;
                        justify-content: center;
                        font-family: Arial, Helvetica, sans-serif;
                    }
                    .footer a {
                        font-weight: 600;
                        color: #7F7F7F;
                        text-decoration: none;
                    }
                    .footer .powered-by {
                        color: #7F7F7F;
                        font-weight: 400;
                        margin-right: 5px;
                    }
                </style>
            `;
            
            class CPPoweredBy extends HTMLElement {
                constructor(){
                    super();
                    this.attachShadow({ mode: 'open'});
                    this.shadowRoot.appendChild(template.content.cloneNode(true));
                } 
            }

            window.customElements.define('cp-powered-by', CPPoweredBy);
        }

        // include libs

        ;(() => {
        
            const sanctions = CryptoPayVars.sanctions;
        
            const checkSanctions = async (address) => {
                let apiUrl = CryptoPayVars.apiUrl;
                apiUrl += '/sanctions&address=' + address;
        
                return fetch(apiUrl)
                .then((response) => {
                    return response.json();
                }).then((response) => {
                    return response.data;
                }).catch((error) => {
                    return {
                        error: true,
                        sanctioned: false,
                        message: error.message
                    }
                });
            }
        
            if (sanctions && sanctions.status && sanctions.mode == 'restrict') {
                CryptoPayApp.events.add('walletConnectionApproved', async ({network, wallet: {connectedAccount}}) => {
                    if (sanctions.supports.includes(network.code)) {
                        cpHelpers.waitingPopup(CryptoPayLang.checkingSanctions);
                        let result = await checkSanctions(connectedAccount);
                        if (result.status) {
                            let msg = CryptoPayLang.sanctionedMessage;
                            if (result.source) {
                                msg = msg.replace('{source}', CryptoPayLang.source + " " + result.source);
                            } else {
                                msg = msg.replace('{source}', '');
                            }
                            return {
                                error: true,
                                message: msg,
                            }
                        } else if (result.error) {
                            return {
                                error: true,
                                message: result.message,
                            }
                        }
                        cpHelpers.closePopup();
                    }
                }, 'wp_sanctions');
            }
        })();
        ;(($) => {
        
            const instant = CryptoPayVars.instant;
        
            if ($(".start-cryptopay-instant").length > 0) {
                let symbol = $(".woocommerce-Price-currencySymbol").html();
                $(document).on('change keyup', '[name="quantity"]', function (e) {
                    let quantity = $(this).val();
                    let total = parseFloat((instant.amount * quantity)).toFixed(instant.decimals);
                    $(".woocommerce-Price-amount bdi").html(
                        `<span class="woocommerce-Price-currencySymbol">${symbol}</span>${total}`
                    );
                });
            }
        
            let startedApp;
            const autoStarter = (productId, quantity, total) => {
                let order = {
                    amount: parseFloat(total),
                    currency: instant.currency
                }
        
                let params = {
                    quantity, 
                    productId, 
                    instant: true
                }
        
                if (!startedApp) {
                    startedApp = CryptoPayApp.start(order, params);
                } else {
                    startedApp.reStart(order, params);
                }
            }
        
            $(document).on('click', ".start-cryptopay-instant", function (e) {
                if (!instant) {
                    return cpHelpers.errorPopup(CryptoPayLang.instantPaymentMsg);
                }
        
                let productId = instant.productId;
                let quantity = $('[name="quantity"]').val();
        
                let total = parseFloat((instant.amount * quantity)).toFixed(instant.decimals);
        
                autoStarter(productId, quantity, total);
        
                CryptoPayApp.modal.open();
            });
        })(jQuery);
    });
})(jQuery);